import { ChevronDown } from 'lucide-react';

import { useNavigationStore } from '@/stores/navigation';

import { NavLink } from './NavLink';

import type { Feature } from '@/types/navigation';
import type { ReactNode } from 'react';

const headerStyle = { color: 'var(--text-muted)' };
const labelStyle = { fontFamily: 'var(--font-mono, monospace)' };
const labelCls =
  'text-[10px] font-medium uppercase tracking-wider whitespace-nowrap';
const btnCls =
  'w-full flex items-center justify-between px-2 py-1.5 rounded-md hover:bg-[#1A1A1A] overflow-hidden';

export function FeatureGroup({ feature }: { feature: Feature }): ReactNode {
  const { expanded, toggle } = useNavigationStore();
  const isExpanded = expanded.has(feature.id);
  const chevronStyle = { transform: isExpanded ? 'rotate(180deg)' : '' };

  return (
    <div className="py-1">
      <button
        onClick={() => toggle(feature.id)}
        style={headerStyle}
        className={btnCls}
      >
        <span style={labelStyle} className={labelCls}>
          {feature.label}
        </span>
        <ChevronDown
          className="w-3 h-3 shrink-0 transition-transform"
          style={chevronStyle}
        />
      </button>
      {isExpanded && (
        <div className="mt-1 space-y-0.5">
          {feature.items.map((item) => (
            <NavLink key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
